import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import {
  Alert,
  PanelGroup,
} from 'react-bootstrap';
import SideBar from '../../components/SideBar/SideBar';
import DeviceGroup from './DeviceGroup';
import EditDevice from './EditDevice';
import './Devices.css';
import { withTranslation } from 'react-i18next';
import {
  isModuleVisible,
  Modules,
} from '../../utils/module-controller';
import NonDeviceList from '../../components/NonDevice/NonDeviceList';

@inject('devicesStore', 'batchStore')
@observer
class Devices extends Component {
  componentDidMount() {
    const { devicesStore } = this.props;
    if (!devicesStore.deviceGUIs.length) {
      devicesStore.loadDeviceGUIs();
    }
    if (!devicesStore.devices.length) {
      devicesStore.loadDevices();
    }
    devicesStore.loadEnums();
  }

  render() {
    const { batchStore, devicesStore, t } = this.props;
    const {
      devicesByType,
      isEditing,
      startEdit,
      confirmDeleteDevice,
      confirmDuplicateDevice,
      portError,
    } = devicesStore;

    const { canEmit } = batchStore;

    return canEmit || isModuleVisible(Modules.DEVICES) ? (
      <SideBar type="devices" title={t('Devices')} icon={'fa-gears'}>
        {isEditing
          ? <EditDevice/>
          : (
            <PanelGroup accordion id="devices" className="fade-in">
              {portError && <Alert bsStyle="warning" className="port-error">{portError}</Alert>}
              {Object.keys(devicesByType).map(key => (
                <DeviceGroup
                  key={key}
                  devices={devicesByType[key]}
                  deviceTypeName={key}
                  onEdit={startEdit}
                  onDelete={confirmDeleteDevice}
                  onDuplicate={confirmDuplicateDevice}
                />
              ))}
              <NonDeviceList/>
            </PanelGroup>
          )
        }
      </SideBar>
    ) : '';
  }
}

export default withTranslation()(Devices);
